import React from 'react';
import { NavItem } from '../../framework/nav/NavItem';
import EntryPoints from '../../framework/nav/EntryPoints';
import { motion, useScroll, useTransform } from "motion/react";
import SideRays from '../../framework/common/SideRays';
import { Carousel as AppleCarousel, Card as AppleCard, CardData } from '../../framework/common/AppleCardsCarousel';

import Container from 'react-bootstrap/Container';
import FlowingMenu from '../../framework/common/FlowingMenu';
import { EncryptedText } from '../../framework/common/EncryptedText';
import { AnimatedTestimonials } from '../../framework/common/AnimatedTestimonials';

const bridge1 = 'https://i.postimg.cc/zDLzGZZ4/Bridge2-1-Small.jpg';

// 3D modelling images
const modBridge1 = 'https://i.postimg.cc/6QGDGL8G/Bridge2-1.png';
const modBridge2 = 'https://i.postimg.cc/nVwDccV8/Bridge4-2.png';
const modCar1 = 'https://i.postimg.cc/cLydtfLm/Car-1-3.jpg';
const modCar3 = 'https://i.postimg.cc/L8ZTNDjF/Car2.png';
const modLightsabers = 'https://i.postimg.cc/nhgRHY4N/Lightsabers-1.jpg';
const modHallway = 'https://i.postimg.cc/08xD4P8r/Hallway-1-7.png';
const modBobaFett = 'https://i.postimg.cc/g2ntFBZv/BobaFett.jpg';

const reactImage = 'https://i.postimg.cc/9fXDydJ9/react.jpg'
const forgeImage = 'https://i.postimg.cc/9fXDydJD/forge.jpg'
const figmaImage = 'https://i.postimg.cc/FKFY0yD1/figma.jpg'
const codingImage = 'https://i.postimg.cc/zfDyTC0L/coding-2.jpg'


const qrcodeproLogo = 'https://i.postimg.cc/jdGP2816/QR-Code-Pro2.png';
const oxalLogo = 'https://i.postimg.cc/1tJDzyx4/oxal-Green.png';
const unsplashLogo = 'https://i.postimg.cc/nhb9pXs0/Unsplash-For-Confluence.png';
const lucamorrowLogo = 'https://i.postimg.cc/k5XhL5nV/LM-4.png';

const qrcodepro = 'https://i.postimg.cc/MKMp1pZf/qrcodepro.jpg';
const oxal = 'https://i.postimg.cc/MH4Zgh5G/oxal.jpg';
const unsplash = 'https://i.postimg.cc/T2HPyDxX/unsplash.jpg';


const experienceCards: CardData[] = [
  {
    category: "Frontend",
    title: "React & TypeScript",
    src: reactImage,
  },
  {
    category: "Platform",
    title: "Atlassian Forge",
    src: forgeImage,
    href: '/#apps',
  },
  {
    category: "Design",
    title: "Figma",
    src: figmaImage,
  },
  {
    category: "Languages & Environments",
    title: "Coding",
    src: codingImage,
    href: '/#apps',
  },
];


const HomeView = () => {
  const { scrollYProgress } = useScroll();

  // Header image scroll effects
  const headerOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  const headerScale = useTransform(scrollYProgress, [0, 0.5], [1, 1.1]);
  
  // Content fade in as you scroll
  const contentOpacity = useTransform(scrollYProgress, [0, 0.2, 0.5], [0, 0.5, 1]);
  const contentY = useTransform(scrollYProgress, [0, 0.2, 0.5], [100, 50, 0]);

  return (
    <>
      <div className='header-container-home'>
        <motion.div 
          className='header-image-home-wrapper'
          style={{ opacity: headerOpacity }}
        >
          <motion.img 
            className='header-image-home' 
            src={bridge1} 
            alt="Bridge"
            style={{ scale: headerScale }}
          />
          <SideRays
            speed={1.6}
            rayColor1="#FCC495"
            rayColor2="#C1F0FF"
            intensity={3}
            spread={2}
            origin="top-left"
            tilt={12}
            saturation={1.2}
            blend={0.4}
            falloff={.9}
            opacity={1.0}
          />
          <div className='header-overlay-home'>
            <h1 className="name">
              <EncryptedText
                text="Luca Morrow"
                encryptedClassName="text-neutral-400"
                revealedClassName=""
                revealDelayMs={200}
                flipDelayMs={100}
              />
            </h1>
            <h4>
              <EncryptedText
                text="Software Developer"
                encryptedClassName="text-neutral-500"
                revealedClassName=""
                revealDelayMs={250}
                flipDelayMs={150}
              />
            </h4>
          </div>
        </motion.div>
      </div>
      <br></br>
      
      <motion.div 
        className='main-container-home'
        style={{ 
          opacity: contentOpacity,
          y: contentY
        }}
      >
          <Container fluid={true}>
            <div className='home-stack'>
              <div className='left-side-container'>
                <p>
                  I'm a third year Software Engineering Student at The University of Sydney and have made a variety of software products. 
                  I've got a passion for front-end development and design, as well as 3D modelling and design. 
                </p>
              </div>

              <div className='right-side-container'>
                <h2>Skills</h2>
                <AppleCarousel
                  items={experienceCards.map((card, index) => (
                    <AppleCard key={card.src} card={card} index={index} />
                  ))}
                />
              </div>
            </div>
          </Container>

          <div style={{ marginTop: '6rem' }}>
            <Container fluid={true}>
              <h2 className="right-col-header">Coding Projects</h2>
            </Container>
            <div style={{ height: '400px', position: 'relative', width: '100%' }}>
              <FlowingMenu
                items={[
                  { link: '/#unsplash-for-confluence', text: 'Unsplash for Confluence', image: unsplashLogo },
                  { link: '/#oxal', text: 'Oxal', image: oxalLogo },
                  { link: '/#qrCodePro', text: 'QR Code Pro', image: qrcodeproLogo },
                  { link: '/', text: 'lucamorrow.com', image: lucamorrowLogo },
                ]}
                bgColor="var(--flowing-menu-bg)"
                textColor="var(--flowing-menu-text)"
                borderColor="var(--flowing-menu-border)"
                marqueeBgColor="var(--flowing-marquee-bg)"
                marqueeTextColor="var(--flowing-marquee-text)"
              />
            </div>
          </div>

          <div style={{ marginTop: '6rem' }}>
            <Container fluid={true}>
              <h2 className="right-col-header">3D Modelling Projects</h2>
              <AnimatedTestimonials
                testimonials={[
                  {
                    src: modBridge1,
                    name: 'Golden Hour',
                    designation: 'Blender · Environmental Render',
                    quote: 'A cinematic 3D render capturing the warm glow of golden hour over a suspension bridge surrounded by rolling forested hills, emphasising natural lighting and volumetric atmosphere.',
                  },
                  {
                    src: modCar1,
                    name: 'Aftermath',
                    designation: 'Blender · Concept Vehicle',
                    quote: 'An original sports car concept designed from scratch in Blender, inspired by the McLaren W1 and Lamborghini Temerario, brought to life within a dramatic 3D scene.',
                  },
                  {
                    src: modBridge2,
                    name: 'Into the Mist',
                    designation: 'Blender · Atmospheric Render',
                    quote: 'A solitary journey across an endless suspension bridge disappearing into the mist. Soft morning light and atmospheric depth create a quiet, cinematic mood.',
                  },
                  {
                    src: modLightsabers,
                    name: 'Relics',
                    designation: 'Blender · Material Study',
                    quote: 'A piece exploring modeling, material creation, lighting, and Blender plugins — rendered in Blender and refined in Photoshop.',
                  },
                  {
                    src: modCar3,
                    name: 'Sunset Apex',
                    designation: 'Blender · University Project',
                    quote: 'A stylised 3D render of a Formula-1 car made for a Sydney University visual design project, combining technical accuracy with a bold illustrative visual style.',
                  },
                  {
                    src: modHallway,
                    name: 'Dystopian Hallway',
                    designation: 'Blender · Lighting Study',
                    quote: 'A study in atmosphere, visual focus, and dramatic lighting through a decayed, cinematic corridor environment.',
                  },
                ]}
              />
            </Container>
          </div>

          <div className="main-footer" style={{ paddingBottom: '6rem' }} />
        </motion.div>
      </>
    );
};

class HomeEntryPoints implements EntryPoints {

  renderFullView = (navItem: NavItem, secondaryNavItems: string[], width: number, height: number): any => {
    return <HomeView />;
  }

  renderIntroView = (navItem: NavItem, secondaryNavItems: string[]): any => {
    return (
      <span>Home intro</span>
    );
  }

}

const homeEntryPoints = new HomeEntryPoints();
export default homeEntryPoints;
